module.exports = __webpack_public_path__ + "img/1.f74757e5.jpg";